export default __webpack_public_path__ + "static/media/number-one.da061187.png";